import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';




const Partners = () => {
  return (
    <Box marginBottom={0}>
      <Typography

        variant="h5"
        align={'center'}
        sx={{
          fontWeight: 150,
        }}
        
      >
        <Box marginBottom={30} maxHeight={50}>
          <Typography variant="h5" align={'center'} color="primary" >
            <strong>
              NATIONAL PUBLIC SCHOOL
            </strong>
              
            <br />YESHWANTHPUR <br />
                  APPLICATION FOR REGISTRATION<br />
            <br />
          </Typography>
          <Box>
                 
            <Typography variant='h6'  color='primary'>
              <strong>APPLICATION NUMBER</strong><br />
            </Typography>
            <Typography variant='h6' >
                YPR/NUR/2022/00981<br />
                YEAR : 2022-23<br />
            </Typography>
          </Box>      
               
        </Box>
        
      </Typography>
    </Box>
  );
  
};
export default Partners;